module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens30-073206f90238267bb5a6139bc0649baf.jpg";